import mainStyles from '../../pages/main.module.css';
import styles from './batchDocumentDownloadModal.module.css';
import ScreenModal from '../ScreenModal/screenModal';
import Button from '../Button/button';

export interface BatchDocumentDownloadModalProps {
  totalDocumentQuantity: number;
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit: () => void
}

function BatchDocumentDownloadModal(props: BatchDocumentDownloadModalProps) {
  const {
    totalDocumentQuantity,
    onCancel,
    onSubmit,
  } = props;

  return (
    <ScreenModal
      customStyles={{
        minWidth: '650px',
        maxHeight: '85%',
        border: 'var(--defaultBorder)',
        display: 'flex',
        flexDirection: 'column',
        color: 'initial',
      }}
    >
      <div className={styles['modal-header']}>
        <div className={styles.title}>
          文書リスト一括ダウンロード
        </div>
      </div>
      <div className={styles['modal-body']}>
        <p>文書リストをダウンロードしますか？</p>
        <div className={styles.form}>
          対象件数：
          {totalDocumentQuantity}
          件
        </div>
        <div className={styles.info}>
          <p>
            ※現在参照している一覧すべての文書が対象です。
          </p>
        </div>
        <div className={styles.alert}>
          <p>ダウンロード準備完了後、メールでダウンロードURLをお知らせします。</p>
          <p className={mainStyles['text-danger']}>※通知メールは他の管理ユーザーにも送信されます。</p>
        </div>
      </div>
      <div className={styles['modal-footer']}>
        <Button size="smaller" color="lighterGray" onClick={onCancel}>キャンセル</Button>
        <Button size="smaller" onClick={onSubmit}>ダウンロード</Button>
      </div>
    </ScreenModal>
  );
}

export default BatchDocumentDownloadModal;
